module.exports = __webpack_public_path__ + "static/media/nav-icon-coaching-engagement-active.4f32f195.svg";